import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import { DSTLogo } from "@/components/dst-logo";
import { Button } from "@/components/ui/button";

export default function NotFound() {
  const { t } = useTranslation();

  return (
    <section className="flex min-h-[420px] flex-col items-center justify-center gap-8 text-center">
      <DSTLogo className="h-24" />
      <div className="space-y-4">
        <p className="text-lg text-muted-foreground uppercase tracking-[0.35em]">
          404
        </p>
        <h1 className="text-balance font-semibold text-3xl text-primary">
          {t("errors.notFound")}
        </h1>
        <p className="text-pretty text-base text-muted-foreground">
          {t("errors.notFoundDescription")}
        </p>
      </div>
      <div className="flex flex-col gap-4 sm:flex-row">
        <Button asChild>
          <Link aria-label="Go home" to="/">
            {t("labels.return-to-homepage")}
          </Link>
        </Button>
      </div>
    </section>
  );
}
